<script setup lang="ts">
import { useJobsSearch } from '@/components/jobs/search'
import { computed, Ref, UnwrapNestedRefs } from 'vue'
import { SearchJobsQuery } from '@/components/jobs/query'

type MaybeRef<T> = Ref<T> | T

const props = defineProps<{
  query: MaybeRef<UnwrapNestedRefs<SearchJobsQuery>>
  currentPage: number
  updatePage: (page: number) => void
}>()

const { hasNextPage, isFetching } = useJobsSearch(props.query)

const previousButtonEnabled = computed<boolean>(() => {
  return props.currentPage > 1
})

const nextButtonEnabled = computed<boolean>(() => !!hasNextPage.value && !isFetching.value)

function goToPreviousPage() {
  if (props.currentPage > 1) props.updatePage(props.currentPage - 1)
}

function goToNextPage() {
  if (hasNextPage) props.updatePage(props.currentPage + 1)
}
</script>

<template>
  <v-col class="shrink">
    <v-btn color="primary" :disabled="!previousButtonEnabled" icon @click="goToPreviousPage">
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>
    <v-btn
      class="btn-font-size btn-no-interact"
      color="primary"
      depressed
      x-small
      :loading="isFetching"
      fab
    >
      {{ currentPage }}
    </v-btn>
    <v-btn color="primary" :disabled="!nextButtonEnabled" icon @click="goToNextPage">
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
  </v-col>
</template>

<style scoped>
.btn-font-size {
  font-size: 14px !important;
}

.btn-no-interact {
  cursor: default;
}
</style>
